/**
 * portfolioData.js — Daftar proyek portofolio DIGITARA
 *
 * Cara menambah proyek baru:
 * 1. Simpan gambar 1:1 di /public/portfolio/nama-file.png
 * 2. Tambahkan entry baru ke array di bawah
 *
 * Field:
 *   id       — slug unik (huruf kecil, tanda hubung)
 *   name     — nama tampilan proyek
 *   url      — link website (dibuka di tab baru saat diklik)
 *   image    — path gambar dari /public (mulai dengan /portfolio/...)
 *   status   — 'online' | 'offline'
 *   year     — tahun pengerjaan (string)
 *   tags     — array kategori singkat (opsional, maks 3)
 */
export const portfolioItems = [
  {
    id: 'bahasa-jepang-bisnis',
    name: 'Bahasa Jepang Bisnis',
    url: 'https://bahasajepangbisnis.groups.id/',
    // Simpan gambar di: public/portfolio/bahasa-jepang-bisnis.png
    image: '/portfolio/bahasa-jepang-bisnis.png',
    icon: '/portfolio/bahasa-jepang-bisnis_icon.png',
    status: 'online',
    year: '2025',
    tags: ['Website', 'Pendidikan'],
  },
  {
    id: 'eling-qurban',
    name: 'Eling Qurban',
    url: 'https://www.elingqurban.my.id/',
    // Simpan gambar di: public/portfolio/eling-qurban.png
    image: '/portfolio/eling-qurban.png',
    icon: '/portfolio/eling-qurban_icon.png',
    status: 'online',
    year: '2025',
    tags: ['Website', 'E-Commerce'],
  },
  {
    id: 'info-ciledug',
    name: 'Info Ciledug',
    url: 'https://infociledug.groups.id/',
    image: '/portfolio/info-ciledug.png',
    icon: '/portfolio/info-ciledug_icon.png',
    status: 'online',
    year: '2026',
    tags: ['Portal Informasi', 'Komunitas'],
  },
  {
    id: 'barulid',
    name: 'Barulid',
    url: 'https://www.barul.my.id/',
    image: '/portfolio/barulid.png',
    icon: null,
    status: 'online',
    year: '2026',
    tags: ['Portfolio', 'Personal'],
  },
  // ── Tambah proyek baru di bawah sini ──────────────────────
  {
    id: 'royal-outdoor',
    name: 'Royal Outdoor',
    url: 'https://royaloutdoor.groups.id/',
    image: '/portfolio/hiking-rental.png',
    icon: '/portfolio/hiking-rental_icon.png',
    status: 'online',
    year: '2026',
    tags: ['Website', 'Rental'],
  },
  {
    id: 'aldis-universe',
    name: 'Aldis Universe',
    url: 'https://aldisuniverse.com/',
    image: '/portfolio/aldis-universe.png',
    icon: '/portfolio/aldis-universe_icon.png',
    status: 'online',
    year: '2026',
    tags: ['Website', 'E-Commerce'],
  },
  {
    id: 'ugh-indonesia',
    name: 'UGH! Indonesia',
    url: 'https://ughindonesia.com/',
    image: '/portfolio/ugh-indonesia.png',
    icon: '/portfolio/ugh-indonesia_icon.png',
    status: 'online',
    year: '2026',
    tags: ['Website', 'Profile', 'E-Commerce'],
  },
  // {
  //   id: 'nama-proyek',
  //   name: 'Nama Proyek',
  //   url: 'https://linkwebsite.com/',
  //   image: '/portfolio/nama-proyek.jpg',
  //   status: 'online',
  //   year: '2026',
  //   tags: ['Website'],
  // },
  {
    id: 'inspira-indonesia',
    name: 'Inspira Indonesia',
    url: 'https://www.inspiraindonesia.com/',
    image: '/portfolio/inspira-indonesia.png',
    icon: '/portfolio/inspira-indonesia_icon.png',
    status: 'online',
    year: '2026',
    tags: ['Website', 'E-Commerce', 'Profile', 'Komunitas'],
  },
  {
    id: 'siomay-gemoy',
    name: 'Siomay Gemoy',
    icon: '/portfolio/siomay-gemoy_icon.png',
    isClientOnly: true,
  },
  {
    id: 'hokky',
    name: 'Hokky',
    icon: '/portfolio/hokky_icon.png',
    isClientOnly: true,
  },
];
